/*
** 后台管理首页
*/

import React, {Component} from 'react';
import { Layout } from 'antd';
import Route from '../../router/router'

import SiderCustom from '../App/common/SiderCustom';
import HeaderCustom from '../App/common/HeaderCustom';
import Footer from '../App/common/Footer';
// import Home from '../App/Home';---不需要

// import { baseUrl } from '../../apis/api'

const {Content} = Layout;

export default class App extends Component {

    constructor(props) {

        super(props);
        
        this.state = {
            key:'',
            openKey:'',
            access_token:''
        };
    }

    componentWillMount(){
         
    }

    componentDidMount() {
        
        if(this.getQueryString('access_token')||sessionStorage.getItem('access_token')){
            if(this.getQueryString('access_token')){
                sessionStorage.setItem('access_token',this.getQueryString('access_token'));
            }
        }else{
            // window.location.href = `${baseUrl}/#/login`;
            this.props.history.push('/login');
        }

        sessionStorage.setItem('key',this.getQueryString('key')?this.getQueryString('key'):'0')
        sessionStorage.setItem('openKey',this.getQueryString('openKey')?this.getQueryString('openKey'):'0')
        this.setState({
            key:sessionStorage.getItem('key'),
            openKey:sessionStorage.getItem('openKey'),
            access_token:sessionStorage.getItem('access_token')
        })
        
    }

    //字符串截取----完成
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
          r=window.location.search.substr(1).match(reg);
        }else{
          r=this.props.location.search.substr(1).match(reg);
        }
        if (r != null) return unescape(r[2]);
        return null;
    }

    render() {

        const { key,openKey,access_token } = this.state;
        const { history, location } = this.props;

        return (

            <Layout className="ant-layout-has-sider" style={{height: '100%'}}>
                <SiderCustom location={location} access_token={access_token} selectedKey={key} openKey={openKey}/>
                <Layout>
                    <HeaderCustom
                        access_token={access_token}
                        history={history}
                    />
                    <Content>
                        {access_token?
                        <Route />
                        :''}
                    </Content>
                    
                    <Footer />
                </Layout>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/page/App/index.js